"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _actionTypes = require("./actionTypes");

/**
 * This is wrapper of thunk action to proceed async action based on RequestActionTypes
 * @param {function(...args)} asyncFn - can be as thunk action or the function that returns a promise.
 * @param {RequestActionTypes} action
 * @returns {function(...[*]): function(*=, *=)}
 */
var createAsyncAction = function createAsyncAction(asyncFn, action) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return function (dispatch, getState, extra) {
      var requestPayload = args.length && [].concat(args);
      var asyncResult = asyncFn.apply(void 0, args);
      dispatch((0, _actionTypes.createPayloadAction)(action.REQUEST, requestPayload));
      if (typeof asyncResult === "function") asyncResult = asyncResult(dispatch, getState, extra);
      return asyncResult.then(function (resultPayload) {
        dispatch((0, _actionTypes.createPayloadAction)(action.SUCCESS, resultPayload));
        return resultPayload;
      })["catch"](function (error) {
        dispatch((0, _actionTypes.createPayloadAction)(action.FAILURE, {
          error: error.code || error
        }));
        throw error;
      });
    };
  };
};

var _default = createAsyncAction;
exports["default"] = _default;